// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"4b38d578","453":"563ea4ce"}[chunkId] + ".chunk.js";
};